//
// import CustomerModel from "@/models/Sale/SlCustomer"
// import UserModel from "@/models/General/GUser"

//
export default {

  /**
   * 
   */
  toList() {
    return [
      {
        name: "alias_search",
        type: "text-field",
        props: {
          label: "Alias",
        },
      },
      {
        name: "types",
        type: "select",
        props: {
          items: [
            {
              text: 'Pack',
              value: 'pack',
            },
            {
              text: 'Item',
              value: 'item',
            },
            {
              text: 'Promo',
              value: 'promo',
            },
          ],
          label: "Tipos",
          multiple: true,
        },
      },
    ]
  }
}
